import { render, staticRenderFns } from "./imgS.vue?vue&type=template&id=77e8c0ec&scoped=true"
var script = {}
import style0 from "./imgS.vue?vue&type=style&index=0&id=77e8c0ec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e8c0ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77e8c0ec')) {
      api.createRecord('77e8c0ec', component.options)
    } else {
      api.reload('77e8c0ec', component.options)
    }
    module.hot.accept("./imgS.vue?vue&type=template&id=77e8c0ec&scoped=true", function () {
      api.rerender('77e8c0ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgS.vue"
export default component.exports